app.directive('youtubePlayer', ['$rootScope', function ($rootScope) {

    return function (scope, element, attrs) {
        const ytplayer = element[0];
        let didPlay = false;
        ytplayer.onload =  () => {

            if(typeof YT !== 'undefined') {

                new YT.Player(ytplayer, {
                    events: {
                        'onStateChange': () => {
                            if(!didPlay){
                                didPlay = true;
                                const title = ytplayer.dataset.title
                                $rootScope.service.tracking.track_event("Video Play", title ? title : "Unknown video");
                            }
                        }
                    }
                });
            }
        }
    };
}]);